import React from "react";
import ContactUsLeftColumn from "./ContactUs/ContactUsLeftColumn";
import ContactUsRightColumnForm from "./ContactUs/ContactUsRightColumnForm";
import { FadeIn } from "../utils/ContactUsFadeEffects";
import ContactSEO from "./../seo/ContactSEO";
import { Helmet } from "react-helmet-async";

export default function Contact() {

  return (
    <main className="max-w-5xl mx-auto px-4 py-12 pt-24">

      <Helmet>
              <title>Madeshwara Ambulance Services | 24/7 Ambulance Services in Bangalore and Karnataka</title>
      </Helmet>

      <ContactSEO />

      <FadeIn direction="bottom">
        <h1 className="text-4xl font-bold mb-10 text-center text-sky-600 font-heading">Contact Us</h1>
      </FadeIn>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8">
        {/* LEFT COLUMN */}
        <FadeIn direction="left">
          <ContactUsLeftColumn />
        </FadeIn>

        {/* RIGHT COLUMN: Contact Form */}
        <FadeIn direction="right">
          <ContactUsRightColumnForm />
        </FadeIn>
      </div>
      
    </main>
  );
}
